import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import { MarkDocumentConfiguration } from "../models/mark-document";
import { ServicePathsSettings } from "src/app/core/configuration/service-paths-settings";


@Injectable({
  providedIn: 'root'
})
export class MarkDocumentService {

  config: MarkDocumentConfiguration;

  constructor(
    private http: HttpClient
  ) {
  }

  timbraDocumento(payload: any) {
    return this.http.post(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_MARK,payload)
  }

  
}
